import { SimpleCard } from "@gull";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NotificationManager } from "react-notifications";
import {
  postSecurityBalance,
  exportSecurityBalance,
} from "app/services/creditService";
import CreditSecurityBalanceSheet from "./CreditSecurityBalanceHeet";
import DebitSecurityBalanceSheet from "./DebitSecurityBalanceSheet";
import AllMemberAutoComplete from "./AllMemberAutoComplete";
import queryStringService from "app/services/queryStringService";
import moment from "moment";
import usePagePermission from "app/hooks/usePagePermission";

const validationSchema = Yup.object().shape({
  memId: Yup.number().required("Please select member"),
  transactionAmount: Yup.number().required("Please enter Transaction Amount"),
  transactionType: Yup.string().required("Please select credit type"),
});

const SecurityBalanceForm = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  const initialValues = {
    memId: "",
    transactionAmount: 0,
    transactionType: "CR",
  };

  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);

    setTimeout(async () => {
      await exportLimitLog();
    }, 10);
  };

  const exportLimitLog = async () => {
    const { FromDate, ToDate, TransactionMode } = initialValues;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      TransactionMode,
    });

    const response = await exportSecurityBalance(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_SecurityBalance.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };

  const submitForm = async (values, { resetForm }) => {
    const res = await postSecurityBalance(values);
    if (res.status === "Success") {
      NotificationManager.success(res.message);
      resetForm({ values: "" });
    } else {
      NotificationManager.error(res.message);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Security Balance</title>
      </Helmet>
      <SimpleCard title="Security Balance" className="mb-4">
        <Formik
          onSubmit={submitForm}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <>
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <div className="form-group">
                      <label className="font-weight-bold">Username</label>
                      <span className="text-danger"> *</span>

                      <AllMemberAutoComplete
                        setFieldValue={setFieldValue}
                        memId={values.memId}
                        handleChangeOptions={(memId) => {
                          setFieldValue("memId", memId);
                        }}
                        name="memId"
                        value={values.memId}
                      />
                      {values.balance ? (
                        <>
                          <b>
                            Wallet Balance : ₹{" "}
                            {Number(values.balance).toFixed(2)}
                          </b>
                        </>
                      ) : (
                        ""
                      )}
                      {!values.memId ? (
                        <p className="text-danger">{errors.memId}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group">
                      <label className="font-weight-bold">Amount</label>
                      <span className="text-danger"> *</span>

                      <Field
                        type="number"
                        className="form-control w-100"
                        name="transactionAmount"
                        display=" Transaction Amount"
                      />
                      <div>
                        <ErrorMessage
                          name="transactionAmount"
                          component="p"
                          className="text-danger"
                        />
                      </div>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-group">
                      <label className="font-weight-bold">
                        Transaction Type
                      </label>
                      <span className="text-danger"> *</span>

                      <Field
                        as="select"
                        className="form-control w-100"
                        name="transactionType"
                        display="DR/ CR"
                      >
                        <option value={"CR"}> Credit</option>
                        <option value={"DR"}> Debit</option>
                      </Field>
                      <div>
                        <ErrorMessage
                          name="transactionType"
                          component="p"
                          className="text-danger"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="form-group">
                  {canAdd && (
                    <button className="btn btn-sm btn-primary" type="submit">
                      {" "}
                      Submit
                    </button>
                  )}
                </div>
              </form>
            </>
          )}
        </Formik>
      </SimpleCard>

      <ul className="nav nav-tabs" role="tablist">
        <li className="nav-item">
          <a
            className="nav-link active"
            href="#profile"
            role="tab"
            data-bs-toggle="tab"
          >
            Credit Security Balance
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#buzz" role="tab" data-bs-toggle="tab">
            Debit Security Balance
          </a>
        </li>
        <li className="nav-item" style={{ marginLeft: "56%" }}></li>
      </ul>

      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active" id="profile">
          <CreditSecurityBalanceSheet />
        </div>
        <div role="tabpanel" className="tab-pane fade" id="buzz">
          <DebitSecurityBalanceSheet />
        </div>
      </div>
    </div>
  );
};

export default SecurityBalanceForm;
